// extracted by mini-css-extract-plugin
export default {"sub-title":"Gv3Yc8pJ","subTitle":"Gv3Yc8pJ","login-box":"HtsDIKpc","loginBox":"HtsDIKpc"};